import type {
	ExaminationTranslations,
	FormTranslations,
	MutationTranslations,
	SharedTranslations,
	ValidationTranslations,
} from "Infrastructure/Translation/Types/examination";

const mutationTranslations: MutationTranslations = {
	updateExaminationSuccess: "Examination was successfully updated",
	updateExaminationError: "Examination update failed",
	createExaminationSuccess: "Examination was successfully created",
	createExaminationError: "Examination creation failed",
	deleteExaminationSuccess: "Examination was successfully deleted",
	deleteExaminationError: "Examination deletion failed",
};

const formTranslation: FormTranslations = {
	examinationDate: "Examination date",
	result: "Result",
	partner: "Partner",
	save: "Save",
	cancel: "Cancel",
	reopen: "Reopen",
	markAsDone: "Mark as done",
	done: "Done",
	delete: "Delete",
};

const sharedTranslations: SharedTranslations = {
	examination: "Examination",
	checkExamination: "Check examination",
	createExamination: "Create examination",
};

const validationTranslations: ValidationTranslations = {
	partnerId: "Partner is required",
	examinationDate: "Examination date is required",
};

export const examinationTranslations: ExaminationTranslations = {
	mutations: mutationTranslations,
	form: formTranslation,
	shared: sharedTranslations,
	validations: validationTranslations,
};
